import dayjs from "dayjs";
import { md5 } from 'js-md5'
import {useAuthStore} from "@/store/auth";
export const sign = () => {
  const userStore = useAuthStore()
  const timestamp = dayjs(Date.now()).format('YYYYMMDDHHmmssSSS')
  const sign = md5(`${timestamp}${userStore.userInfo.F_UserId}WiseduTestKey`)
  return {
    signStr: sign,
    timestamp
  }
}
